import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersComponent } from './customers/customers.component';
import { DetailComponent } from './customers/detail/detail.component';
import { DocumentsComponent } from './documents/documents.component';
import { OrdersComponent } from './orders/orders.component';
import { TemplatesComponent } from './templates/templates.component';

const routes: Routes = [
  { path: 'customers', component: CustomersComponent },
  { path: 'customers/:customerId', component: DetailComponent },
  { path: 'documents', component: DocumentsComponent },
  { path: 'orders', component: OrdersComponent },
  { path: 'document-template', component: TemplatesComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ESignRoutingModule { }
